/**
 * @description 全局别名hook
 * @demo const openingAreaAlias = useGlobalAlias('openingArea');
 */
import { useContext, useEffect, useState } from 'react';
import { getTenantInfo as getTenantInfoApi } from 'src/common/api/system';
import { changeTenantInfo } from '@/store/common';
import store from '@/store/store';
import { urlParams } from '@lhb/func';
import UserInfoContext from '@/layout/context';

interface TenantInfoResponse {
  globalAliasItemVOs: Array<{ code: string; alias: string, defaultName: string }>;
}

// 定义类型
type GlobalAliasCodeEnumType = {
  [key: string]: string;
};

// 使用大写表示常量对象
const GLOBAL_ALIAS_CODE_ENUM: GlobalAliasCodeEnumType = {
  'standardChancePoint': '机会点',
  'standardFranchisee': '加盟商',
  'standardTask': '拓店任务',
  'brandBusinessArea': '品牌商圈',
  'openingArea': '商圈', // 开店区域/商圈
} as const;

type GlobalAliasCodeKeys = keyof typeof GLOBAL_ALIAS_CODE_ENUM;
export function useGlobalAlias(code: GlobalAliasCodeKeys) {
  const { shareId, ...params } = urlParams(location.search) || {};
  // const tenantInfo = useSelector((state: any) => state.common.tenantInfo) || {}; // 如果组件不在 Provider 中，会报错
  const { tenantInfo } = useContext(UserInfoContext) || {};
  const [alias, setAlias] = useState<string>(GLOBAL_ALIAS_CODE_ENUM[code] || '');

  async function getTenantInfo() {
    try {
      const response: TenantInfoResponse = await getTenantInfoApi(); // 和 h5 不是同一个接口
      const data = response || {};

      const item = (data?.globalAliasItemVOs || []).find((item: { code: string; alias: string, defaultName: string }) => item.code === code);
      const _alias = item?.alias || item?.defaultName || GLOBAL_ALIAS_CODE_ENUM[code];

      setAlias(_alias);

      if (_alias) {
        store.dispatch(changeTenantInfo(data || {}));
      }
    } catch (error) {
      console.error('Failed to fetch tenant info:', error);
    }
  }

  useEffect(() => {
    if ((!tenantInfo || !Array.isArray(tenantInfo.globalAliasItemVOs) || !tenantInfo.globalAliasItemVOs.length) && !shareId) {
      getTenantInfo();
    } else if (shareId && Object.keys(params).includes(String(code))) {
      // console.log('params', params, Object.keys(params).includes(String(code)), decodeURIComponent(params[code]));
      setAlias(decodeURIComponent(params[code]) || GLOBAL_ALIAS_CODE_ENUM[code]);
    } else {
      const item = (tenantInfo.globalAliasItemVOs || []).find((item: { code: string; alias: string }) => item.code === code);
      const _alias = item?.alias || item?.defaultName || GLOBAL_ALIAS_CODE_ENUM[code];
      setAlias(_alias);
    }
  }, []);

  return alias;
}
